import * as React from 'react';

export interface LoadingContextValues {
  getLoading: (key: string) => boolean;
  setLoading: (key: string, loading: boolean) => void;
  loading: boolean;
}

export const LoadingContext = React.createContext<LoadingContextValues>({
  getLoading: key => true,
  setLoading: (key, loading) => {},
  loading: false,
});
